import type {
  HTMLSmileLivenessUiElement,
  SmileLivenessUiConfiguration,
} from '@innovatrics/dot-auto-capture-ui/smile-liveness';

import '@innovatrics/dot-auto-capture-ui/smile-liveness';
import { useEffect } from 'react';

export const SmileCameraUi = (props: SmileLivenessUiConfiguration) => {
  useEffect(() => {
    const uiElement = document.getElementById('x-dot-smile-liveness-ui') as HTMLSmileLivenessUiElement | null;

    if (uiElement) {
      uiElement.configuration = props;
    }
  });

  return <x-dot-smile-liveness-ui id="x-dot-smile-liveness-ui" />;
};
